module.exports = __webpack_public_path__ + "f837229f42848ef23a40b05318f4426b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/swimsuit-neon-green.png
// module id = 1396
// module chunks = 0